"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiFreeSpinPanel = void 0;
var _pixi = require("pixi.js");
var _gsap = _interopRequireDefault(require("gsap"));
var _core = require("@dragon/core");
var _pixiGame = require("@dragon/pixi-game");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiFreeSpinPanel = exports.PixiFreeSpinPanel = /*#__PURE__*/function (_PixiGameComponent) {
  /**
   * Base class for a free spin panel. Extend this to get bunch of features and handling for free.
   * Override what you wish
   * 
   * @param componentName 
   * @param logo the game logo implementation, might be hidden when fs starts
   * @param style the style applied to the counter text.
   * @param bgTexture background texture for the panel. leave null for none
   */
  function PixiFreeSpinPanel(componentName, style, bgTexture, position) {
    var _this;
    _classCallCheck(this, PixiFreeSpinPanel);
    _this = _callSuper(this, PixiFreeSpinPanel, [componentName, position]);
    _defineProperty(_this, "_text", void 0);
    _defineProperty(_this, "_bg", void 0);
    _defineProperty(_this, "_lastKnownPlayed", void 0);
    _defineProperty(_this, "_lastKnownToBePlayed", void 0);
    /**
     * This is used to prevent the free spin counter from updating while the retrigger animation is playing.
     * Don't forget to set this to false when the retrigger animation is done or the counter will not update anymore.
     */
    _defineProperty(_this, "_retriggerInProgress", void 0);
    _this.alpha = 0;
    _this.visible = true;
    if (bgTexture) {
      _this._bg = new _pixi.Sprite(_pixi.Texture.from(bgTexture));
      _this._bg.anchor.set(0.5);
      _this.addChild(_this._bg);
    }
    _this._text = new _pixi.Text("", style);
    _this._text.anchor.set(0.5);
    _this._text.text = "Free spin\n";
    _this._text.resolution = 2;
    _this.addChild(_this._text);
    _core.CORE.subscribe('game.freeSpinsPlayed', _this.freeSpinsUpdate.bind(_this));
    return _this;
  }
  _inherits(PixiFreeSpinPanel, _PixiGameComponent);
  return _createClass(PixiFreeSpinPanel, [{
    key: "hide",
    value: function hide() {
      _gsap["default"].to(this, {
        alpha: 0,
        duration: 0.5
      });
    }
  }, {
    key: "show",
    value: function show() {
      if (this.alpha != 1) {
        _gsap["default"].to(this, {
          alpha: 1,
          duration: 0.5
        });
        this.freeSpinsUpdate(_core.CORE.getState().game.freeSpinsPlayed);
      }
    }
    /**
     * 
     */
  }, {
    key: "freeSpinsUpdate",
    value: function freeSpinsUpdate(played) {
      if (this._retriggerInProgress) return;
      //We need to prevent this from firing if there is an active "retrigger" animation, else the counter will show strange values. count up, down then up again.

      var toBePlayed = _core.CORE.getState().game.freeSpinsAwarded;
      if (played == undefined) played = _core.CORE.getState().game.freeSpinsPlayed;
      if (toBePlayed == 0) toBePlayed = 10;
      this._lastKnownPlayed = played;
      this._lastKnownToBePlayed = toBePlayed;
      var t = _core.CORE.translate("freespinsleft").replace('{0}', played.toString()).replace('{1}', toBePlayed.toString());
      this._text.text = t;
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiFreeSpinPanel.js.map